import IAction from '@signageos/actions/dist/IAction';

export const DeviceRemoteControlSet = 'Device.RemoteControl.Set';
export interface DeviceRemoteControlSet extends IAction<typeof DeviceRemoteControlSet> {
	enabled: boolean;
}
